import { DEFAULT_WORKFLOW_OWNER_EMAIL } from '../../constants'
import { ConductorWorkflow } from './workflow.types'

export const createConductorWorkflow = ({
  name,
  description,
  inputParameters,
  tasks
}: Pick<
  ConductorWorkflow,
  'name' | 'description' | 'inputParameters' | 'tasks'
>): ConductorWorkflow => {
  return {
    name,
    description,
    tasks,
    inputParameters,
    outputParameters: {},
    variables: {},
    ownerEmail: DEFAULT_WORKFLOW_OWNER_EMAIL,
    schemaVersion: 2
  }
}
